/* Mom's Organic thema v2 — winkelwagen-drawer, quick-add, variant-picker, menu's.
   Geen dependencies. Werkt progressief: zonder JS blijven cart-pagina en formulieren functioneren. */
(function () {
  'use strict';

  var doc = document;

  function qs(sel, root) { return (root || doc).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }

  /* ---------- Headerhoogte als CSS-var (sticky filterbalk) ---------- */
  function meetHeader() {
    var header = qs('.mo-header');
    if (header) {
      doc.documentElement.style.setProperty('--mo-header-offset', (header.offsetHeight - 1) + 'px');
    }
  }
  window.addEventListener('resize', meetHeader);
  if (doc.fonts && doc.fonts.ready) { doc.fonts.ready.then(meetHeader); }

  /* ---------- Drawer & overlay ---------- */
  function drawerEl() { return qs('#mo-cart-drawer .mo-drawer') || qs('.mo-drawer'); }
  function overlayEl() { return qs('[data-cart-overlay]'); }

  function openCart() {
    var d = drawerEl(), o = overlayEl();
    if (!d) return;
    d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    doc.body.style.overflow = 'hidden';
    var closeBtn = qs('[data-cart-close]', d);
    if (closeBtn) closeBtn.focus();
  }
  function closeCart() {
    var d = drawerEl(), o = overlayEl();
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    doc.body.style.overflow = '';
  }

  function openMenu() {
    var m = qs('#mo-mobile-menu'), o = qs('[data-menu-overlay]');
    if (!m) return;
    m.classList.add('is-open');
    if (o) o.classList.add('is-open');
    doc.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    var m = qs('#mo-mobile-menu'), o = qs('[data-menu-overlay]');
    if (m) m.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    doc.body.style.overflow = '';
  }

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); closeLoc(); }
  });

  /* ---------- Localisatie-popover ---------- */
  function closeLoc() {
    qsa('[data-loc-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); });
    qsa('[data-loc-toggle][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  /* ---------- Cart-sectie herrenderen (Section Rendering API) ---------- */
  function herlaadDrawer(openNa) {
    var wrapper = qs('#mo-cart-drawer');
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (wrapper && data['cart-drawer']) {
          var open = drawerEl() && drawerEl().classList.contains('is-open');
          var tmp = doc.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var vers = qs('#mo-cart-drawer', tmp);
          if (vers) wrapper.innerHTML = vers.innerHTML;
          if (open || openNa) {
            var d = drawerEl();
            if (d) { d.style.transition = 'none'; d.classList.add('is-open'); void d.offsetHeight; d.style.transition = ''; }
            var o = overlayEl();
            if (o) o.classList.add('is-open');
            doc.body.style.overflow = 'hidden';
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () { /* stil; cart-pagina blijft altijd werken */ });
  }

  function voegToe(items, openNa) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    }).then(function () { return herlaadDrawer(openNa !== false); });
  }

  function wijzigRegel(line, qty) {
    var d = drawerEl();
    if (d) d.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () {
        if (qs('[data-cart-page]')) { window.location.reload(); return; }
        return herlaadDrawer(false);
      })
      .then(function () { var d2 = drawerEl(); if (d2) d2.classList.remove('is-loading'); });
  }

  /* ---------- Kortingscode ---------- */
  function chipCodes() {
    return qsa('[data-discount-chip]').map(function (c) { return c.getAttribute('data-discount-chip') || ''; });
  }

  function stuurKorting(codes, daarna) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes })
    }).then(function () {
      if (qs('[data-cart-page]')) { window.location.reload(); return; }
      return herlaadDrawer(false).then(function () { if (daarna) daarna(); });
    }).catch(function () { /* stil */ });
  }

  function pasKortingToe(wrap) {
    var input = wrap && qs('[data-discount-input]', wrap);
    var code = input && input.value.trim();
    if (!code) return;
    var knop = qs('[data-discount-apply]', wrap);
    if (knop) knop.disabled = true;
    var alle = chipCodes();
    alle.push(code);
    stuurKorting(alle.join(','), function () {
      /* na herrenderen: staat de code als chip in de cart? Zo niet → ongeldig */
      var raak = false;
      chipCodes().forEach(function (c) { if (c.toLowerCase() === code.toLowerCase()) raak = true; });
      if (!raak) {
        var wrap2 = qs('[data-discount-wrap]');
        if (wrap2) {
          var det = qs('details', wrap2);
          if (det) det.setAttribute('open', '');
          var input2 = qs('[data-discount-input]', wrap2);
          if (input2) input2.value = code;
          var fout = qs('[data-discount-error]', wrap2);
          if (fout) fout.hidden = false;
        }
      }
    });
  }

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.closest && e.target.closest('[data-discount-input]')) {
      e.preventDefault();
      pasKortingToe(e.target.closest('[data-discount-wrap]'));
    }
  });

  /* ---------- Event-delegatie ---------- */
  doc.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-discount-apply]'))) {
      e.preventDefault();
      pasKortingToe(t.closest('[data-discount-wrap]'));
      return;
    }
    if ((t = e.target.closest('[data-discount-remove]'))) {
      e.preventDefault();
      var chip = t.closest('[data-discount-chip]');
      var weg = chip ? (chip.getAttribute('data-discount-chip') || '').toLowerCase() : '';
      var rest = chipCodes().filter(function (c) { return c.toLowerCase() !== weg; });
      stuurKorting(rest.join(','));
      return;
    }

    if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeCart(); return; }

    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-overlay]')) { closeMenu(); return; }

    if ((t = e.target.closest('[data-loc-toggle]'))) {
      e.preventDefault();
      var panel = qs('[data-loc-panel]', t.parentElement);
      var open = panel && panel.classList.contains('is-open');
      closeLoc();
      if (panel && !open) { panel.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if (!e.target.closest('[data-loc-panel]')) { closeLoc(); }

    if ((t = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      var vid = t.getAttribute('data-variant-id');
      if (vid) {
        t.disabled = true;
        voegToe([{ id: parseInt(vid, 10), quantity: 1 }]).then(function () { t.disabled = false; });
      }
      return;
    }

    if ((t = e.target.closest('[data-qty-plus],[data-qty-minus]'))) {
      var wrap = t.closest('.mo-qty');
      var input = wrap && qs('[data-qty-input]', wrap);
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        val += t.hasAttribute('data-qty-plus') ? 1 : -1;
        if (val < 1) val = 1;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if ((t = e.target.closest('[data-line-plus],[data-line-minus],[data-line-remove]'))) {
      e.preventDefault();
      var line = parseInt(t.getAttribute('data-line'), 10);
      var huidige = parseInt(t.getAttribute('data-line-qty'), 10) || 1;
      if (t.hasAttribute('data-line-remove')) { wijzigRegel(line, 0); }
      else if (t.hasAttribute('data-line-plus')) { wijzigRegel(line, huidige + 1); }
      else { wijzigRegel(line, huidige - 1); }
      return;
    }
  });

  /* ---------- Productformulieren (PDP) ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = qs('[data-variant-input]', form) || qs('[name="id"]', form);
    var qtyInput = qs('[data-qty-input]', form);
    var id = idInput && parseInt(idInput.value, 10);
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (!id) return;
    var knop = qs('[type="submit"]', form);
    if (knop) knop.disabled = true;
    voegToe([{ id: id, quantity: qty }]).then(function () { if (knop) knop.disabled = false; });
  });

  /* ---------- Variant-picker ---------- */
  function geldFormat(centen) {
    var bedrag = (centen / 100).toFixed(2).replace('.', ',');
    return '€' + bedrag;
  }

  function initVariantPicker(picker) {
    var jsonEl = qs('[data-product-json]', picker.closest('section, .shopify-section, form') || doc);
    if (!jsonEl) jsonEl = qs('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = picker.closest('form') || qs('form[data-product-form]');
    var input = form && (qs('[data-variant-input]', form) || qs('[name="id"]', form));
    var qtyInput = form && qs('[data-qty-input]', form);

    function huidigeVariant() {
      var id = input && parseInt(input.value, 10);
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) return product.variants[i];
      }
      return product.variants[0];
    }

    function update() {
      var v = huidigeVariant();
      if (!v) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      qsa('[data-variant-option]', picker).forEach(function (btn) {
        var actief = parseInt(btn.getAttribute('data-variant-id'), 10) === v.id;
        btn.classList.toggle('is-active', actief);
        btn.setAttribute('aria-pressed', actief ? 'true' : 'false');
      });

      var prijsEl = qs('[data-price]');
      if (prijsEl) prijsEl.textContent = geldFormat(v.price);
      var compareEl = qs('[data-compare-price]');
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = geldFormat(v.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      var badgeEl = qs('[data-sale-badge]');
      if (badgeEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          badgeEl.textContent = '−' + pct + '%';
          badgeEl.hidden = false;
        } else { badgeEl.hidden = true; }
      }
      qsa('[data-total-price]').forEach(function (el) { el.textContent = geldFormat(v.price * qty); });

      var atc = form && qs('[type="submit"]', form);
      var atcTekst = form && qs('[data-atc-text]', form);
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          if (atcTekst) atcTekst.textContent = atc.getAttribute('data-label-add') || 'In winkelwagen';
        } else {
          atc.disabled = true;
          if (atcTekst) atcTekst.textContent = atc.getAttribute('data-label-soldout') || 'Uitverkocht — binnenkort terug';
        }
      }
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-option]');
      if (!btn || !input) return;
      e.preventDefault();
      input.value = btn.getAttribute('data-variant-id');
      update();
    });
    if (qtyInput) qtyInput.addEventListener('change', update);
    update();
  }

  /* ---------- PDP-galerij: slider met pijlen, thumbs en swipe ---------- */
  function initGallery(gal) {
    var track = qs('[data-gallery-track]', gal);
    if (!track) return;
    var slides = qsa('.mo-pdp__slide', track);
    var prev = qs('[data-gallery-prev]', gal);
    var next = qs('[data-gallery-next]', gal);
    var thumbs = qsa('[data-gallery-thumb]', gal);

    function huidige() {
      if (track.clientWidth === 0) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    /* doel is leidend voor de pijlen: snel doorklikken telt zo gewoon op,
       ook terwijl de smooth-scroll van de vorige klik nog loopt */
    var doel = 0;
    var vorigeIndex = -1;

    function updateUI(i) {
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      /* actieve thumb in beeld houden — via scrollLeft op alleen de thumbrij;
         scrollIntoView zou de smooth-scroll van de track onderbreken */
      if (i !== vorigeIndex) {
        vorigeIndex = i;
        var actief = thumbs[i];
        if (actief && actief.parentElement) {
          var wrap = actief.parentElement;
          var links = actief.offsetLeft;
          var rechts = links + actief.offsetWidth;
          if (links < wrap.scrollLeft) { wrap.scrollLeft = links - 12; }
          else if (rechts > wrap.scrollLeft + wrap.clientWidth) { wrap.scrollLeft = rechts - wrap.clientWidth + 12; }
        }
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    function gaNaar(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      doel = i;
      var zacht = true;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { zacht = false; }
      track.scrollTo({ left: i * track.clientWidth, behavior: zacht ? 'smooth' : 'auto' });
      updateUI(i); /* pijlen/thumbs direct bijwerken, niet wachten op scroll-events */
    }

    function update() { updateUI(huidige()); }

    if (prev) prev.addEventListener('click', function () { gaNaar(doel - 1); });
    if (next) next.addEventListener('click', function () { gaNaar(doel + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        gaNaar(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); gaNaar(doel - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); gaNaar(doel + 1); }
    });

    var raf, rustTimer;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
      /* na handmatig swipen: doel gelijkzetten zodra het scrollen tot rust komt */
      clearTimeout(rustTimer);
      rustTimer = setTimeout(function () { doel = huidige(); }, 120);
    });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Init ---------- */
  function init() {
    meetHeader();
    qsa('[data-variant-picker]').forEach(initVariantPicker);
    qsa('[data-gallery]').forEach(initGallery);
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  window.MoTheme = { openCart: openCart, closeCart: closeCart, herlaadDrawer: herlaadDrawer };
})();
